import { Link, useMatch } from "react-router-dom";
import styled from "styled-components";

type CustomNavLinkProps = {
  to: string;
  matchLinks: string[];
  children: React.ReactNode;
  style?: any;
};

const CustomLink = styled(Link)`
  all: unset;

  width: 100%;
  cursor: pointer;
  box-sizing: border-box;

  border-radius: 12px;
  padding: 10px 4px;
  gap: 8px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  font-size: 12px;
  font-weight: 500;
  color: var(--color-black-9, #344054);

  background: var(--bg-white);

  span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  i,
  svg {
    font-size: 18px;
    flex-shrink: 0;
    color: var(--color-black-9, #344054);
  }

  :hover {
    background: var(--primary-10);
    color: var(--color-purple);

    i,
    svg {
      color: var(--color-purple);
    }
  }

  &.active {
    background: var(--primary-10);
    color: var(--color-purple);
    font-weight: 600;

    i,
    svg {
      color: var(--color-purple);
    }
  }
`;

export function CustomNavLink({
  to,
  matchLinks,
  children,
  style,
}: CustomNavLinkProps) {
  const match = useMatch(matchLinks[0]);
  const match2 = useMatch(matchLinks[1]);

  return (
    <CustomLink
      {...{ to }}
      className={match || match2 ? "active" : ""}
      style={style}
    >
      {children}
    </CustomLink>
  );
}
